module.exports = __webpack_public_path__ + "img/C73428.cfd1d615.png";